import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MomentModule } from 'ngx-moment';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import {
    NotificationIconPipe,
    LoadingIndicatorComponent,
    ModuleInfoButtonComponent,
} from '@qwyk/ui-standalone';
import {
    NotificationsFacade,
    PortalsNotificationsStateModule,
} from '@qwyk/portals/data-access/notifications';

import { NotificationComponent } from './components/notification/notification.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { NotificationDetailComponent } from './components/notification-detail/notification-detail.component';

@NgModule({
    imports: [
        CommonModule,
        MomentModule,
        RouterModule,
        TooltipModule,
        TranslateModule,
        FontAwesomeModule,
        OverlayPanelModule,
        NotificationIconPipe,
        LoadingIndicatorComponent,
        ModuleInfoButtonComponent,
        RouterModule.forChild([
            {
                path: '',
                component: NotificationsComponent,

            }
        ]),
        PortalsNotificationsStateModule
    ],
    declarations: [
        NotificationsComponent,
        NotificationComponent,
        NotificationDetailComponent,
    ],
    providers: [NotificationsFacade],
})
export class PortalsNotificationsModule {}
